import { buildRoutesMap, route } from 'redux-saga-first-router';
import { homeNavigate } from 'screens/Home/sagas';
import { loginNavigate } from 'screens/Login/sagas';
import { accountNavigate } from 'screens/Account/sagas';
import { purchaseNavigate } from 'screens/Purchase/sagas';
import { purchaseHistoryNavigate } from 'screens/PurchaseHistory/sagas';
import { unpaidPurchaseNavigate } from 'screens/UnpaidPurchase/sagas';
import { renewNavigate } from 'screens/Renew/sagas';
import { billingNavigate } from 'screens/Billing/sagas';
import { addCardNavigate } from 'screens/AddCard/sagas';
import { orderSimNavigate } from 'screens/OrderSim/sagas';
import { sprintSubscriptionNavigate, bypassedSubscriptionNavigate } from 'screens/Subscription/sagas';
import { sprintAddDataNavigate, bypassedAddDataNavigate } from 'screens/AddData/sagas';
import { sprintAddDataPurchaseNavigate, bypassedAddDataPurchaseNavigate, quickAddDataPurchaseNavigate } from 'screens/AddDataPurchase/sagas';
import { insurancePurchaseNavigate } from 'screens/InsurancePurchase/sagas';
import { sprintInsuranceConfirmNavigate, bypassedInsuranceConfirmNavigate } from 'screens/InsuranceConfirm/sagas';
import { sprintInsurancePlanNavigate, bypassedInsurancePlanNavigate } from 'screens/InsurancePlan/sagas';
import { sprintInsuranceDeviceNavigate, bypassedInsuranceDeviceNavigate } from 'screens/InsuranceDevice/sagas';
import { sprintInsuranceNavigate, bypassedInsuranceNavigate } from 'screens/Insurance/sagas';
import { insuranceEligibilityNavigate } from 'screens/InsuranceEligibility/sagas';
import { paymentArrangementRequestNavigate } from 'screens/PaymentArrangementRequest/sagas';

export default buildRoutesMap(
  route('INSURANCE_ELIGIBILITY', '/device-protection/eligibility', insuranceEligibilityNavigate),
  route('INSURANCE_PURCHASE', '/device-protection/contracts/:contractId/purchases/:purchaseId/pay', insurancePurchaseNavigate),
  route('SPRINT_INSURANCE_CONFIRM', '/s/subscriptions/:subId/device-protection/:sku/:insPlanId/confirm', sprintInsuranceConfirmNavigate),
  route('SPRINT_INSURANCE_PLAN', '/s/subscriptions/:subId/device-protection/:sku/select-plan', sprintInsurancePlanNavigate),
  route('SPRINT_INSURANCE_DEVICE', '/s/subscriptions/:subId/device-protection/select-device', sprintInsuranceDeviceNavigate),
  route('SPRINT_INSURANCE', '/s/subscriptions/:subId/device-protection', sprintInsuranceNavigate),
  route('BYPASSED_INSURANCE_CONFIRM', '/a/subscriptions/:subId/device-protection/:sku/:insPlanId/confirm', bypassedInsuranceConfirmNavigate),
  route('BYPASSED_INSURANCE_PLAN', '/a/subscriptions/:subId/device-protection/:sku/select-plan', bypassedInsurancePlanNavigate),
  route('BYPASSED_INSURANCE_DEVICE', '/a/subscriptions/:subId/device-protection/select-device', bypassedInsuranceDeviceNavigate),
  route('BYPASSED_INSURANCE', '/a/subscriptions/:subId/device-protection', bypassedInsuranceNavigate),
  route('QUICK_INSURANCE_CONFIRM', '/q/subscriptions/:subId/device-protection/:sku/:insPlanId/confirm', bypassedInsuranceConfirmNavigate),
  route('QUICK_INSURANCE_PLAN', '/q/subscriptions/:subId/device-protection/:sku/select-plan', bypassedInsurancePlanNavigate),
  route('QUICK_INSURANCE_DEVICE', '/q/subscriptions/:subId/device-protection/select-device', bypassedInsuranceDeviceNavigate),
  route('QUICK_INSURANCE', '/q/subscriptions/:subId/device-protection', bypassedInsuranceNavigate),
  route('SPRINT_ADD_DATA_PURCHASE', '/s/subscriptions/:subId/add-data/plan/:planId', sprintAddDataPurchaseNavigate),
  route('BYPASSED_ADD_DATA_PURCHASE', '/a/subscriptions/:subId/add-data/plan/:planId', bypassedAddDataPurchaseNavigate),
  route('QUICK_ADD_DATA_PURCHASE', '/q/subscriptions/:subId/add-data/plan/:planId', quickAddDataPurchaseNavigate),
  route('SPRINT_ADD_DATA', '/s/subscriptions/:subId/add-data', sprintAddDataNavigate),
  route('QUICK_ADD_DATA', '/q/subscriptions/:subId/add-data', bypassedAddDataNavigate),
  route('BYPASSED_ADD_DATA', '/a/subscriptions/:subId/add-data', bypassedAddDataNavigate),
  route('SPRINT_SUBSCRIPTION', '/s/subscriptions/:subId', sprintSubscriptionNavigate),
  route('BYPASSED_SUBSCRIPTION', '/a/subscriptions/:subId', bypassedSubscriptionNavigate),
  route('QUICK_SUBSCRIPTION', '/q/subscriptions/:subId', bypassedSubscriptionNavigate),
  route('RENEW', '/purchases/renew', renewNavigate),
  route('UNPAID_PURCHASE', '/purchases/:purchaseId/pay', unpaidPurchaseNavigate),
  route('PURCHASE', '/purchases/:purchaseId', purchaseNavigate),
  route('PURCHASE_HISTORY', '/billing/history', purchaseHistoryNavigate),
  route('ADD_CARD', '/billing/add-card', addCardNavigate),
  route('BILLING', '/billing', billingNavigate),
  route('ACCOUNT', '/account', accountNavigate),
  route('PAYMENT_ARRANGEMENT_REQUEST', '/pa-request-form', paymentArrangementRequestNavigate),
  route('LOGIN', '/login', loginNavigate),
  route('RESET_PASSWORD', '/reset-password'),
  route('HOME', '/', homeNavigate),
);

const routeDefaults = {
  type: 'router/NAVIGATE',
}

export const login = () => ({
  ...routeDefaults,
  id: 'LOGIN',
  path: '/login',
});

export const resetPassword = () => ({
  ...routeDefaults,
  id: 'RESET_PASSWORD',
  path: '/reset-password',
})

export const home = () => ({
  ...routeDefaults,
  id: 'HOME',
  path: '/',
});

export const purchase = (purchaseId) => ({
  ...routeDefaults,
  id: 'PURCHASE',
  params: { purchaseId },
  path: `/purchases/${purchaseId}`,
});

export const purchaseHistory = (page = 1) => ({
  ...routeDefaults,
  id: 'PURCHASE_HISTORY',
  query: { page },
  path: `/billing/history`,
});

export const unpaidPurchase = (purchaseId) => ({
  ...routeDefaults,
  id: 'UNPAID_PURCHASE',
  params: { purchaseId },
  path: `/purchases/${purchaseId}/pay`,
});

export const account = () => ({
  ...routeDefaults,
  id: 'ACCOUNT',
  path: '/account',
});

export const renewSubscriptions = () => ({
  ...routeDefaults,
  id: 'RENEW',
  path: '/purchases/renew',
});

export const billing = () => ({
  ...routeDefaults,
  id: 'BILLING',
  path: '/billing',
});

export const addCard = () => ({
  ...routeDefaults,
  id: 'ADD_CARD',
  path: '/billing/add-card',
});

export const sprintSubscription = (subId) => ({
  ...routeDefaults,
  id: 'SPRINT_SUBSCRIPTION',
  params: { subId },
  path: `/s/subscriptions/${subId}`,
});

export const bypassedSubscription = (subId) => ({
  ...routeDefaults,
  id: 'BYPASSED_SUBSCRIPTION',
  params: { subId },
  path: `/a/subscriptions/${subId}`,
});

export const quickSubscription = (subId) => ({
  ...routeDefaults,
  id: 'QUICK_SUBSCRIPTION',
  params: { subId },
  path: `/q/subscriptions/${subId}`,
});

export const sprintAddData = (subId) => ({
  ...routeDefaults,
  id: 'SPRINT_ADD_DATA',
  params: { subId },
  path: `/s/subscriptions/${subId}/add-data`,
});

export const bypassedAddData = (subId) => ({
  ...routeDefaults,
  id: 'BYPASSED_ADD_DATA',
  params: { subId },
  path: `/a/subscriptions/${subId}/add-data`,
});

export const sprintAddDataPurchase = (subId, planId) => ({
  ...routeDefaults,
  id: 'SPRINT_ADD_DATA_PURCHASE',
  params: { subId, planId },
  path: `/s/subscriptions/${subId}/add-data/plan/${planId}`
});

export const bypassedAddDataPurchase = (subId, planId) => ({
  ...routeDefaults,
  id: 'BYPASSED_ADD_DATA_PURCHASE',
  params: { subId, planId },
  path: `/a/subscriptions/${subId}/add-data/plan/${planId}`
});

export const quickAddData = (subId) => ({
  ...routeDefaults,
  id: 'QUICK_ADD_DATA',
  params: { subId },
  path: `/q/subscriptions/${subId}/add-data`,
});

export const quickAddDataPurchase = (subId, planId) => ({
  ...routeDefaults,
  id: 'QUICK_ADD_DATA_PURCHASE',
  params: { subId, planId },
  path: `/q/subscriptions/${subId}/add-data/plan/${planId}`
});

export const quickInsurance = (subId) => ({
  ...routeDefaults,
  id: 'QUICK_INSURANCE',
  params: { subId },
  path: `/q/subscriptions/${subId}/device-protection`,
});
export const quickInsuranceDevice = (subId) => ({
  ...routeDefaults,
  id: 'QUICK_INSURANCE_DEVICE',
  params: { subId },
  path: `/q/subscriptions/${subId}/device-protection/select-device`,
});
export const quickInsurancePlan = (subId, sku, deviceId) => ({
  ...routeDefaults,
  id: 'QUICK_INSURANCE_PLAN',
  params: { subId, sku },
  path: `/q/subscriptions/${subId}/device-protection/${sku}/select-plan`,
  query: { deviceId },
});
export const quickInsuranceConfirm = (subId, sku, insPlanId, deviceId) => ({
  ...routeDefaults,
  id: 'QUICK_INSURANCE_CONFIRM',
  params: { subId, sku, insPlanId },
  path: `/q/subscriptions/${subId}/device-protection/${sku}/${insPlanId}/confirm`,
  query: { deviceId },
});

export const bypassedInsurance = (subId) => ({
  ...routeDefaults,
  id: 'BYPASSED_INSURANCE',
  params: { subId },
  path: `/a/subscriptions/${subId}/device-protection`,
});
export const bypassedInsuranceDevice = (subId) => ({
  ...routeDefaults,
  id: 'BYPASSED_INSURANCE_DEVICE',
  params: { subId },
  path: `/a/subscriptions/${subId}/device-protection/select-device`,
});
export const bypassedInsurancePlan = (subId, sku, deviceId) => ({
  ...routeDefaults,
  id: 'BYPASSED_INSURANCE_PLAN',
  params: { subId, sku },
  path: `/a/subscriptions/${subId}/device-protection/${sku}/select-plan`,
  query: { deviceId },
});
export const bypassedInsuranceConfirm = (subId, sku, insPlanId, deviceId) => ({
  ...routeDefaults,
  id: 'BYPASSED_INSURANCE_CONFIRM',
  params: { subId, sku, insPlanId },
  path: `/a/subscriptions/${subId}/device-protection/${sku}/${insPlanId}/confirm`,
  query: { deviceId },
});

export const sprintInsurance = (subId) => ({
  ...routeDefaults,
  id: 'SPRINT_INSURANCE',
  params: { subId },
  path: `/s/subscriptions/${subId}/device-protection`,
});
export const sprintInsuranceDevice = (subId) => ({
  ...routeDefaults,
  id: 'SPRINT_INSURANCE_DEVICE',
  params: { subId },
  path: `/s/subscriptions/${subId}/device-protection/select-device`,
});
export const sprintInsurancePlan = (subId, sku) => ({
  ...routeDefaults,
  id: 'SPRINT_INSURANCE_PLAN',
  params: { subId, sku },
  path: `/s/subscriptions/${subId}/device-protection/${sku}/select-plan`,
});
export const sprintInsuranceConfirm = (subId, sku, insPlanId) => ({
  ...routeDefaults,
  id: 'SPRINT_INSURANCE_CONFIRM',
  params: { subId, sku, insPlanId },
  path: `/s/subscriptions/${subId}/device-protection/${sku}/${insPlanId}/confirm`,
});

export const insurancePurchase = (purchaseId, contractId) => ({
  ...routeDefaults,
  id: 'INSURANCE_PURCHASE',
  params: { purchaseId, contractId },
  path: `/device-protection/contracts/${contractId}/purchases/${purchaseId}/pay`
});

export const insuranceEligibility = () => ({
  ...routeDefaults,
  id: 'INSURANCE_ELIGIBILITY',
  path: `/device-protection/eligibility`
});


export const paymentArrangementRequest = (query) => ({
  ...routeDefaults,
  id: 'PAYMENT_ARRANGEMENT_REQUEST',
  path: `/pa-request-form`,
  query,
});
